// Role hierarchy — must match backend.
export const ROLE_RANKS = { user: 1, manager: 2, admin: 3, master_admin: 4 };
export const LEGACY_ROLE_MAP = { rep: "user" };

export const rank = (role) => {
  const normalized = LEGACY_ROLE_MAP[role] || role || "user";
  return ROLE_RANKS[normalized] || 1;
};

export const atLeast = (role, minRole) => rank(role) >= rank(minRole);

// The accounts team at a gym they aren't assigned to can only look (the server refuses writes too).
export const canWrite = (user) => !user?.view_only;

export const ROLE_LABELS = {
  user: "User",
  manager: "Manager",
  admin: "Admin",
  master_admin: "Master Admin",
};

export const ROLE_DESCRIPTIONS = {
  user: "Enter data (Front End Sales, All Sales, Members, Expenses, Leads).",
  manager: "Everything a user can do + Dashboard (excluding rep leaderboard) + invite users.",
  admin: "Everything a manager can do + full dashboard reports including rep leaderboard.",
  master_admin: "Full access including incentive slabs and script library.",
};
